module.exports = __webpack_public_path__ + "static/media/ki.fe178156.svg";